//PARTICIPATING BRANDS for VN
import shopee from "src/Common/Components/ParticipatingBrands/Assets/Imgs/Shopee.jpg";
import shopeeFood from "src/Common/Components/ParticipatingBrands/Assets/Imgs/ShopeeFood1.jpg";
import garena from "src/Common/Components/ParticipatingBrands/Assets/Imgs/garena.jpg";
import ocha from "src/Common/Components/ParticipatingBrands/Assets/Imgs/Ocha2.jpg";
import prudential from "src/Common/Components/ParticipatingBrands/Assets/Imgs/Prudential.jpg";
import phuongTrang from "src/Common/Components/ParticipatingBrands/Assets/Imgs/PhuongTrang.jpg";
import vexere from "src/Common/Components/ParticipatingBrands/Assets/Imgs/vexere.jpg";
import galaxy from "src/Common/Components/ParticipatingBrands/Assets/Imgs/galaxy.jpg";
import vntrip from "src/Common/Components/ParticipatingBrands/Assets/Imgs/vntrip.jpg";
import domino from "src/Common/Components/ParticipatingBrands/Assets/Imgs/domino.jpg";
import cellphones from "src/Common/Components/ParticipatingBrands/Assets/Imgs/cellphones.png";
import homeCredit from "src/Common/Components/ParticipatingBrands/Assets/Imgs/homeCredit.jpg";
import lotte from "src/Common/Components/ParticipatingBrands/Assets/Imgs/lotte.jpg";
import cinestar from "src/Common/Components/ParticipatingBrands/Assets/Imgs/Cinestar.jpg";
import pti from "src/Common/Components/ParticipatingBrands/Assets/Imgs/PTI.jpg";
import popz from "src/Common/Components/ParticipatingBrands/Assets/Imgs/popz.jpg";
import saigonzoo from "src/Common/Components/ParticipatingBrands/Assets/Imgs/saigonzoo.jpg";
import nct from "src/Common/Components/ParticipatingBrands/Assets/Imgs/NCT.jpg";
import fahasa from "src/Common/Components/ParticipatingBrands/Assets/Imgs/fahasa.jpg";
import cliptv from "src/Common/Components/ParticipatingBrands/Assets/Imgs/clipTV.jpg";
import icankid from "src/Common/Components/ParticipatingBrands/Assets/Imgs/icankid.jpg";
import ahamove from "src/Common/Components/ParticipatingBrands/Assets/Imgs/ahamove.jpg";
import cgv from "src/Common/Components/ParticipatingBrands/Assets/Imgs/CGV.jpg";
import cooky from "src/Common/Components/ParticipatingBrands/Assets/Imgs/cooky.jpg";
import feCredit from "src/Common/Components/ParticipatingBrands/Assets/Imgs/FEcredit.jpg";
import unica from "src/Common/Components/ParticipatingBrands/Assets/Imgs/Unica.jpg";
import savista from "src/Common/Components/ParticipatingBrands/Assets/Imgs/savista.jpg";
import urbox from "src/Common/Components/ParticipatingBrands/Assets/Imgs/urbox.jpg";
import kidsplaza from "src/Common/Components/ParticipatingBrands/Assets/Imgs/kidsplaza.jpg";
import vtvcab from "src/Common/Components/ParticipatingBrands/Assets/Imgs/vtvcab.jpg";
import ssc from "src/Common/Components/ParticipatingBrands/Assets/Imgs/SSC.jpg";
import sctv from "src/Common/Components/ParticipatingBrands/Assets/Imgs/sctv.jpg";
import sevenEleven from "src/Common/Components/ParticipatingBrands/Assets/Imgs/7eleven.jpg";
import circleK from "src/Common/Components/ParticipatingBrands/Assets/Imgs/circleK.jpg";
import hocmai from "src/Common/Components/ParticipatingBrands/Assets/Imgs/hocmai.jpg";
import vascara from "src/Common/Components/ParticipatingBrands/Assets/Imgs/vascara.jpg";
import goldenGate from "src/Common/Components/ParticipatingBrands/Assets/Imgs/goldenGate.jpg";
import gs25 from "src/Common/Components/ParticipatingBrands/Assets/Imgs/GS25.jpg";
import guardian from "src/Common/Components/ParticipatingBrands/Assets/Imgs/guardian.jpg";

//Merchant
import merchantSevenEleven from "../Imgs/merchant/7eleven.jpg";
import logoCK from "../Imgs/merchant/logoCK.jpg";
import GS25 from "../Imgs/merchant/GS25.jpg";
import plLogo from "../Imgs/merchant/plLogo.jpg";
import koi from "../Imgs/merchant/koi.jpg";
import kfc from "../Imgs/merchant/kfc.jpg";
import miniStop from "../Imgs/merchant/miniStop.jpg";
import innisfree from "../Imgs/merchant/innisfree.jpg";
import familyMartLogo from "../Imgs/merchant/familyMart.jpg";
import guardianLogo from "../Imgs/merchant/guardianLogo.jpg";
import beardpapa from "../Imgs/merchant/beardpapa.jpg";
import burgerKingLogo from "../Imgs/merchant/burgerKing.jpg";
import canifa from "../Imgs/merchant/canifa.jpg";
import chewyJunior from "../Imgs/merchant/chewyJunior.jpg";
import fptLogo from "../Imgs/merchant/fpt.jpg";
import grandCastellaLogo from "../Imgs/merchant/grandCastella.jpg";
import gutaCafe from "../Imgs/merchant/gutaCafe.jpg";
import hotColdLogo from "../Imgs/merchant/hotCold.jpg";
import kioskFiveStar from "../Imgs/merchant/kioskFiveStar.jpg";
import logoComTam from "../Imgs/merchant/logoComTam.jpg";
import lotteria from "../Imgs/merchant/lotteria.jpg";
import medicare from "../Imgs/merchant/medicare.jpg";
import parisBaguette from "../Imgs/merchant/parisBaguette.jpg";
import shilin from "../Imgs/merchant/shilin.jpg";

export const ImgLinks = {
    shopee, shopeeFood, garena, ocha, prudential, phuongTrang, vexere,
    galaxy, vntrip, domino, cellphones, homeCredit, lotte, cinestar, pti, popz, saigonzoo,
    nct, fahasa, cliptv, icankid, ahamove, cgv, cooky, feCredit, unica, savista,
    urbox, kidsplaza, vtvcab, ssc, sctv, sevenEleven, circleK, hocmai, vascara, 
    goldenGate, gs25, guardian
}

export const merchantImgLinks = {
    merchantSevenEleven, logoCK, GS25, plLogo, koi, kfc, miniStop, innisfree, familyMartLogo, 
    guardianLogo, beardpapa, burgerKingLogo, canifa, chewyJunior, fptLogo, grandCastellaLogo, 
    gutaCafe, hotColdLogo, kioskFiveStar, logoComTam, lotteria, medicare, parisBaguette, shilin
}
